export const CANCEL_REASONING = [
  { type: 'reason', reason: 'Verandering van plannen' },
  { type: 'reason', reason: 'Onvoorziene omstandigheden' },
  { type: 'reason', reason: 'Betere deal gevonden' },
  { type: 'reason', reason: 'Negatieve reviews' },
  { type: 'different', reason: 'Anders namelijk' },
]
